import { Buffer } from 'buffer';

const isValidObject = (obj: any) => typeof obj === 'object' && obj !== null;

const isObjWithKeys = (obj: any) => (isValidObject(obj) ? Object.keys(obj).length > 0 : false);

const isNonEmptyArray = (array: any) => !!(array && Array.isArray(array) && array.length);

const isEmptyArray = (array: any) => !isNonEmptyArray(array);

const base64Encode = (str: string) => Buffer.from(str).toString('base64');

const base64Decode = (str: string) => Buffer.from(str).toString('base64');

export { isObjWithKeys, isNonEmptyArray, isEmptyArray, base64Encode, base64Decode };
